module.exports = __webpack_public_path__ + "static/img/img_1.03a7b15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_1.png
// module id = eYNI
// module chunks = 1